module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_02-3f8d7e42c69b588bae6237d904b2ee35.png";